function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResizeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6152"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6151"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 706",
    d: "M357.312 167.229H354.7v1.227h2.612l-1.455 1.458.871.871 2.942-2.942-2.942-2.942-.871.871z",
    transform: "translate(-341.67 -158.842)",
    style: {
      fill: "#ffa539"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 707",
    d: "M2.358 168.456H4.97v-1.227H2.358l1.455-1.458-.871-.871L0 167.842l2.942 2.942.871-.871z",
    transform: "translate(0 -158.842)",
    style: {
      fill: "#ffa539"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 707",
    transform: "translate(6.557)",
    style: {
      fill: "#14a4c2"
    },
    d: "M0 0h1.844v18H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 708",
    transform: "translate(9.9)",
    style: {
      fill: "#14a4c2"
    },
    d: "M0 0h1.844v18H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResizeIcon);
export default __webpack_public_path__ + "static/media/resizeIcon.976168f17d1094c842ccb86dab08bca1.svg";
export { ForwardRef as ReactComponent };